import { useParams, Routes, Route } from 'react-router-dom';

import { Product } from '../Product';
import { Root } from './views/Root';

import { Menu as NestedMenu } from '../Menu/views/Root/containers/Menu';
import { Container } from '../GlobalComponents/Container';
import { Flex } from '../GlobalComponents/Flex';
import { Outer } from '../Layout/Router/Outer';

export const Menu: React.FC = () => {
	const params = useParams();

	const routes = (
		<Routes>
			<Route path="/" element={<Outer />}>
				<Route path=":groupId/*" element={<Menu />} />
				<Route path="product/*" element={<Product />} />
			</Route>
		</Routes>
	);

	return (
		<Flex $justifyContent="center">
			<Container width={'1140'}>
				{params['*'] !== '' ? (
					routes
				) : !params.groupId ? (
					<>
						<Root />
						{routes}
					</>
				) : (
					<>
						<NestedMenu id={params.groupId} />

						{routes}
					</>
				)}
			</Container>
		</Flex>
	);

	// if (params['*'] !== '') {
	// 	return routes;
	// }

	// if (!params.groupId) {
	// 	return (
	// 		<>
	// 			<Root />

	// 			{routes}
	// 		</>
	// 	);
	// }

	// return (
	// 	<>
	// 		<NestedMenu id={params.groupId} />

	// 		{routes}
	// 	</>
	// );
};
